import { productForSkuIdSelector, upgradeProductSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIContactSalesButton from 'ui-addon-upgrades/button/UIContactSalesButton';
import { ADD_ON_CARD, APP, SCREENS } from 'pricing-pages-ui/constants/tracking/Locations';
import { jsx as _jsx } from "react/jsx-runtime";
const CTAContainer = styled.div.withConfig({
  displayName: "AddOnCardFallbacks__CTAContainer",
  componentId: "sc-1163z83-0"
})(["display:flex;flex-direction:column;align-items:stretch;"]);
export const AddOnCardCTAFallback = ({
  skuId
}) => {
  const {
    apiName
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [skuId]
  }));
  const upgradeData = {
    app: APP,
    screen: SCREENS.PRODUCTS_PLANS,
    uniqueId: `${ADD_ON_CARD}-${upgradeProduct}`,
    upgradeProduct
  };
  return /*#__PURE__*/_jsx(CTAContainer, {
    children: /*#__PURE__*/_jsx(UIContactSalesButton, {
      apiName: apiName,
      upgradeData: upgradeData
    })
  });
};
export const AddOnCardPricingFallback = () => null;